export const GET_CYCLE_HIRE = 'GET_CYCLE_HIRE';

// Toggle cycleHire
export const toggleCycleHire = () => {
	return {
		type: 'TOGGLE_CYCLE_HIRE',
	}
}

// Get Cycle Hire
export const getCycleHire = (hireComp, lat, lng) => {

	return {
		type: 'GET_CYCLE_HIRE',
		options: {
			hireComp,
			lat,
			lng
		}
	}
}

// Put Cycle Hire
export const putCycleHire = (cycleHire = [], cycleHireType) => {

	return {
		type: 'PUT_CYCLE_HIRE',
		payload: {
			cycleHire,
			cycleHireType,
		}
	}
}

// Clear all cycleHire
export const clearCycleHire = () => {

	return {
		type: 'CLEAR_CYCLE_HIRE',
	}
}

// Remove POI
export const removeCycleHire = (cycleHireType) => {
	return {
		type: 'REMOVE_CYCLE_HIRE',
		options: {
			cycleHireType,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/cycleHire.js